import http from "../http";

export default {
  indexChampTeamsSquads(champ_team_id) {
    return http.plainAxiosInstance.get(`/champ_teams/${champ_team_id}/squads`);
  },

  createSquad(newSquad) {
    const {
      edition_modality_id,
      team_id,
      status_id,
      player_id,
      player_attributes
    } = newSquad;
    return http.plainAxiosInstance.post(`/squads`, {
      squad: {
        edition_modality_id,
        team_id,
        status_id,
        player_id,
        player_attributes
      }
    });
  },
  updateSquad(squad) {
    const {
      id,
      edition_modality_id,
      team_id,
      status_id,
      player_id,
      player_attributes
    } = squad;
    return http.plainAxiosInstance.put(`/squads/${id}`, {
      squad: {
        id,
        edition_modality_id,
        team_id,
        status_id,
        player_id,
        player_attributes
      }
    });
  },
  showChampTeamsSquad(champ_team_id, squad_id) {
    return http.plainAxiosInstance.get(
      `/champ_teams/${champ_team_id}/squads/${squad_id}`
    );
  }
};
